import createFolder from './create-folder';
import previewFile from './preview-file';
import deleteResource from './delete-resource';
import download from './download';
import upload from './upload';
import folderupload from './folder-upload';
import rename from './rename';
import sort from './sort';
import editDescription from './edit-description';
import markAsInsuredVisible from './mark-as-insured-visible';
import unmarkAsInsuredVisible from './unmark-as-insured-visible';
import moveTo from './move-to';
import copyTo from './copy-to';
import send from './send';
import selectOneDriveRootFolder from './select-one-drive-root-folder';
import resetOneDriveRootFolder from './reset-one-drive-root-folder';
import loginOneDrive from './login-onedrive';
import logoutOneDrive from './logout-onedrive';
import selectGoogleDriveRootFolder from './select-google-drive-root-folder';
import resetGoogleDriveRootFolder from './reset-google-drive-root-folder';
import loginGoogleDrive from './login-googledrive';

import createNote from './create-note';
import createTask from './create-task';
import createServiceRequest from './create-service-request';

const capabilities = [
  createFolder,
  previewFile,
  rename,
  editDescription,
  markAsInsuredVisible,
  unmarkAsInsuredVisible,
  moveTo,
  copyTo,
  send,
  download,
  upload,
  folderupload,
  deleteResource,
  sort,
  selectOneDriveRootFolder,
  resetOneDriveRootFolder,
  loginOneDrive,
  logoutOneDrive,
  selectGoogleDriveRootFolder,
  resetGoogleDriveRootFolder,
  loginGoogleDrive,

  createNote,
  createTask,
  createServiceRequest,
];

/**
 * Actions' fields list:
 *  showDialog,
 *  hideDialog,
 *  navigateToDir,
 *  updateNotifications,
 *  getSelection,
 *  getSelectedResources,
 *  getResource,
 *  getResourceChildren,
 *  getResourceLocation,
 *  getNotifications,
 *  getSortState,
 *  refresh,
 *  controlConfiguration,
 *  ownerType,
 *
 *  Called from FileNavigator (componentDidMount() and componentWillReceiveProps())
 *
 * @param apiOptions
 * @param {object} actions
 * @returns {array}
 */
export default (apiOptions, actions) => {
  return capabilities.map((capability) => capability(apiOptions, actions));
};
